import * as React from 'react';
import './NavMenu.css';
// import Iframe from 'react-iframe';

// import FlowerMiner from './miner/FlowerMiner';
import { User } from '../App';
import { GitlabUrl, DiscordServerUrl } from '../consts';

import glImg from '../images/gitlab.png';
// const twImg = require('../images/twitter.png');
import diImg from '../images/discord.png';
import logo from '../images/nadeko-top.png';
// import arrowUp from '../images/icon-arrow-up.svg';
// import arrowDown from '../images/icon-arrow-down.svg';
import iconLogin from '../images/icon-login.svg';
// import iconProfile from '../images/icon-logout.svg';
// import mine from '../images/mine.svg';
// tslint:disable-next-line:max-line-length
const DISCORD_AUTH_URL = '/login';

// const MINER_URL = process.env.NODE_ENV === 'development'
    // ? 'http://localhost:3001'
    // : MinerUrl;

export interface Props {
    user: User | null;
}

export interface State {
    tabOpen: TabState;
    mining: boolean;
}

type TabState = 'miner' | 'profile' | null;

export default class NavMenu extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            tabOpen: null,
            mining: false,
        };
    }
    toggleTab(t: TabState) {
        this.setState((prev) => {
            if (t === prev.tabOpen) {
                return {
                    tabOpen: null
                };
            }
            return {
                tabOpen: t
            };
        });
    }
    minerToggle(val: boolean) {
        if (this.state.mining !== val) {
            this.setState({
                mining: val
            });
        }
    }
    render() {
        const user = this.props.user;

        return (
            <nav>
                <section className="nav-left-wrap">

                    <div className="nav-left">
                        <a href={'https://nadeko.bot/'}>
                            <div className="logo">
                                <img src={logo} alt="NadekoBot_Logo" />
                                <span style={{color: "white"}} >NadekoBot</span>
                            </div>
                        </a>
                        <a className="social gitlab" target="_blank" rel="noopener noreferrer" href={GitlabUrl}>
                            <img src={glImg} alt="NadekoBot_Github_Logo" />
                        </a>
                        <a className="social discord" target="_blank" rel="noopener noreferrer" href={DiscordServerUrl}>
                            <img src={diImg} alt="NadekoBot_Discord_Logo" />
                        </a>
                    </div>
                </section>

                <section className="nav-right">
                    <div className="miner-wrap">
                        {/* <div
                            className="miner-menu"
                            onClick={() => this.props.user == null
                                ? window.location.href = DISCORD_AUTH_URL
                                : this.toggleTab('miner')
                            }
                        >

                            <span>
                                {this.state.mining && <img
                                    alt=""
                                    src={mine}
                                    style={({ width: '50px', margin: '0px 10px -15px -15px' })}
                                />}
                                Miner
                                </span>
                            <img alt="" src={this.state.tabOpen === 'miner' ? arrowUp : arrowDown} />
                        </div>

                        {this.state.tabOpen === 'miner' &&
                            <Iframe
                                url={MINER_URL}
                                width="500px"
                                className="miner-iframe"
                            />} */}
                    </div>

                    {user == null
                       ? (<a className="login" href={DISCORD_AUTH_URL}>
                           <img alt="" src={iconLogin} />
                           <span>Login</span>
                       </a>)
                       : (<div
                           className="profile-menu"
                           onClick={() => this.toggleTab('profile')}
                       >
                           <img alt="" src={user.avatar} />
                           <span>{user.name}</span>
                       </div>)}

                    {this.state.tabOpen === 'profile' &&
                        <div className="profile-wrap">
                            <div className="profile">
                                {user == null
                                    ? 'don\'t kill me'
                                    : (
                                        <div className="profile-info">
                                            <img
                                                alt=""
                                                src={user.avatar}
                                            />
                                            <p>{user.name}</p>
                                        </div>
                                    )
                                }
                            </div>
                            <a
                                href="/logout"
                                rel="noopener noreferrer"
                                className="logout"
                                onClick={() => this.toggleTab('profile')}
                            >
                                <img alt="" src={iconLogin} />
                                <span>Logout</span>
                            </a>
                        </div>
                    }
                </section>
            </nav>);
    }
}
